import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, CircularProgress } from '@mui/material';
import TerminalOrangeButton from './TerminalOrangeButton';

export const formatDeletedDocumentLabel = ({ number, date, useHash = false }) => {
  const num = number != null && String(number).trim() !== '' ? String(number).trim() : '';
  const prefix = useHash ? '#' : '№';
  const numberPart = num ? `${prefix} ${num}` : '';
  const dateStr = date ? new Date(date).toLocaleDateString('uk-UA') : '';
  return [numberPart, dateStr].filter(Boolean).join(' від ');
};

const MarkDeletedDialog = ({ open, onClose, onConfirm, loading, documentLabel, error }) => (
  <Dialog
    open={open}
    onClose={loading ? undefined : onClose}
    PaperProps={{
      sx: {
        bgcolor: '#ffebee',
        border: '2px solid',
        borderColor: 'error.main',
      },
    }}
  >
    <DialogTitle sx={{ color: 'error.main', fontWeight: 700 }}>Помітити на видалення?</DialogTitle>
    <DialogContent>
      <Typography>
        Помітити на видалення документ {documentLabel || ''}?
      </Typography>
      {error ? (
        <Typography color="error" sx={{ mt: 1.5 }}>
          {error}
        </Typography>
      ) : null}
    </DialogContent>
    <DialogActions sx={{ px: 2, pb: 2 }}>
      <TerminalOrangeButton
        onClick={onClose}
        disabled={loading}
        sx={{ bgcolor: 'transparent', color: 'text.primary', boxShadow: 'none' }}
      >
        Скасувати
      </TerminalOrangeButton>
      <Button
        variant="contained"
        color="error"
        disableElevation
        onClick={onConfirm}
        disabled={loading}
        sx={{ textTransform: 'none', fontWeight: 700 }}
      >
        {loading ? <CircularProgress size={22} color="inherit" /> : 'Так'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default MarkDeletedDialog;
